import { UnitLoader } from './UnitLoader';

export const unitLoader: { (token?: string): UnitLoader } = (token) => new UnitLoader(token);
